var lib_core = require("lib-core");

var Editor2DController = require("./editor2D/editor2DController.js");

var AbstractViewerController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(AbstractViewerController, lib_core.Controller);
AbstractViewerController.inject = {
    editorController : Editor2DController
};
module.exports = AbstractViewerController;

AbstractViewerController.prototype.beforeLoad = function() {
    var self = this;

    lib_core.Controller.prototype.beforeLoad.call(this);

    if(!this.configuration.collection_configs) {
        this.editorController.registerDataModelView(this.getDataType(),
            this.getViewCollection(), this.getInteractionModelType(),
            this.getInteractionViewType(), [this.configuration.layers, this.configuration], this.configuration.IMOptions);
    } else {
        this.configuration.collection_configs.forEach(function (collection_config) {
            self.editorController.registerDataModelView(self.getDataType(),
                self.getViewCollection(collection_config.collection), self.getInteractionModelType(),
                self.getInteractionViewType(), [collection_config.layers, collection_config], collection_config.IMOptions);
        });
    }
};

AbstractViewerController.prototype.getDataType = function () {
    // has to be implemented by child classes
    console.error("Not implemented");
};

AbstractViewerController.prototype.getInteractionModelType = function () {
    // has to be implemented by child classes
    console.error("Not implemented");
};

AbstractViewerController.prototype.getInteractionViewType = function () {
    // has to be implemented by child classes
    console.error("Not implemented");
};

AbstractViewerController.prototype.getViewCollection = function (collection) {
    if(collection) {
        return this.root.findByPath(collection);
    } else if(this.configuration.collection) {
        return this.root.findByPath(this.configuration.collection);
    } else if(this.parent()) {
        return this.parent().getViewCollection();
    } else return null;
};

